{
  var ProductPage = {
    data: {},

    init: function () {
      if (
        document.querySelector("[data-customizer]") ||
        document.querySelector("[data-bundle]")
      )
        this.data.form = PwnageProductFormComplex
      if (document.querySelector("[data-product]"))
        this.data.form = PwnageProductFormSimple

      PwnageFormUtility.SliderManager.init()
      this.data.form.init()
      PwnageFormUtility.URLManager.init()
      PwnageFormUtility.PriceManager.init()
      this.data.form.bindUIActions()
      this.data.form.initUI()
    },
  }

  document.addEventListener("DOMContentLoaded", () => {
    const autoPlayPauseVideosViewport = () => {
      const videos = document.querySelectorAll(".autoPlayViewport")
      videos.forEach((video) => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              video.pause()
            } else if (video.paused) {
              video.play()
            }
          })
        })
        observer.observe(video)
      })
    }
    autoPlayPauseVideosViewport()

    const mobileCheckerHelper = {
      init() {
        this.addMobileClassToBody()
        this.addCheckTouch()

        window.addEventListener("resize", (e) => {
          this.addMobileClassToBody()
        })
      },
      addMobileClassToBody() {
        if (
          window.innerWidth <= 767 ||
          (window.innerWidth <= 1280 && window.innerWidth > window.innerHeight)
        ) {
          document.body.classList.add("mobile")
          return
        }
        document.body.classList.remove("mobile")
      },
      addCheckTouch() {
        window.addEventListener("pointerdown", (e) => {
          if (e.pointerType == "touch") {
            document.body.classList.add("touch")
            return
          }
          document.body.classList.remove("touch")
        })
      },
    }
    mobileCheckerHelper.init()

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault()
        e.stopPropagation()

        if (link.getAttribute("href") == "#subscribe") {
          document.querySelector('#subscribe input[type="email"]').focus()
        }

        document.querySelector(link.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start",
        })
      })
    })

    const ToTopHelper = {
      init() {
        this.toTopBtn = document.querySelector(".to-top")

        this.bindEvents()
      },
      bindEvents() {
        window.addEventListener(
          "scroll",
          (e) => {
            if (window.scrollY > window.innerHeight)
              this.toTopBtn.classList.remove("to-top--init")
            else this.toTopBtn.classList.add("to-top--init")
          },
          { passive: true }
        )

        this.toTopBtn.addEventListener("click", () => {
          scroll({ top: 0, behavior: "smooth" })
          this.toTopBtn.classList.remove("to-top--init")
        })
      },
    }
    ToTopHelper.init()

    function initSwipers() {
      if (document.getElementById("index")) {
        let swiper = new Swiper("#style__phones", {
          slidesPerView: 2,
          spaceBetween: 130,
          centeredSlides: true,
          updateOnImagesReady: true,
          loop: true,
          speed: 500,
          autoplay: {
            delay: 2000,
            disableOnInteraction: false,
          },
          // Responsive breakpoints
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 50,
            },
            1024: {
              slidesPerView: 2,
            },
          },
        })
      }

      let swipers = []
      document.querySelectorAll(".swiper-boxes").forEach((swiperBox) => {
        swipers.push(
          new Swiper(swiperBox, {
            slidesPerView: "auto",
            spaceBetween: 25,
            centeredSlides: true,
            breakpoints: {
              1280: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 25,
                allowTouchMove: false,
                centeredSlides: false,
              },
            },
          })
        )
      })
      document
        .querySelectorAll(".swiper-boxes-2:not(.swiper-recommended)")
        .forEach((swiperBox) => {
          swipers.push(
            new Swiper(swiperBox, {
              observer: true,
              slidesPerView: "auto",
              spaceBetween: 25,
              freeMode: true,
              freeModeMomentumVelocityRatio: 1,
              freeModeMomentumRatio: 0.2,
              watchOverflow: true,
              scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                hide: false,
              },
              breakpoints: {
                1500: {
                  spaceBetween: 40,
                },
              },
            })
          )
        })
      document
        .querySelectorAll(".swiper-boxes-no-margin")
        .forEach((swiperBox) => {
          swipers.push(
            new Swiper(swiperBox, {
              slidesPerView: "auto",
              centeredSlides: true,
              spaceBetween: 0,
              watchOverflow: true,
              slideToClickedSlide: true,
              grabCursor: true,
              initialSlide:
                [
                  ...swiperBox.querySelector('[data-roadmap-state="current"]')
                    .parentElement.childNodes,
                ].indexOf(
                  swiperBox.querySelector('[data-roadmap-state="current"]')
                ) || 0,
            })
          )
        })
      document.querySelectorAll(".swiper-tabs").forEach((swiperBox) => {
        swipers.push(
          new Swiper(swiperBox, {
            slidesPerView: "auto",
            spaceBetween: 0,
            centeredSlides: false,
            freeMode: true,
            freeModeMomentumVelocityRatio: 1,
            freeModeMomentumRatio: 0.2,
            watchOverflow: true,
          })
        )
      })
      document.querySelectorAll(".gallery").forEach((gallery) => {
        swipers.push(
          new Swiper(gallery, {
            // navigation: {
            // 	nextEl: '.swiper-button-next',
            //  	prevEl: '.swiper-button-prev',
            // },
            freeMode: true,
            slidesPerView: "auto",
            centeredSlides: false,
            spaceBetween: 0,
            freeModeMomentumVelocityRatio: 1,
            freeModeMomentumRatio: 0.3,
            longSwipesRatio: 2,
            observeSlideChildren: true,
            centeredSlidesBounds: true,
          })
        )
      })
    }
    initSwipers()

    if (
      document.querySelector("[data-customizer]") ||
      document.querySelector("[data-product]") ||
      document.querySelector("[data-bundle]")
    ) {
      ProductPage.init()
    }
  })

  window.addEventListener("load", () => {
    document.querySelectorAll("[data-lazyload-src]").forEach((imageEl) => {
      imageEl.src = imageEl.dataset.lazyloadSrc
    })
  })

  // TODO fix this modal interaction
  document.addEventListener("shopify:section:load", function (event) {
    if (event.detail.sectionId === "add-to-cart-modal") {
      var theModalEl = document.querySelector("[data-modal-prepurchase]")
      if (
        ProductPage.data.ajaxController.prepurchaseModal &&
        ProductPage.data.ajaxController.prepurchaseModal.hide
      ) {
        ProductPage.data.ajaxController.prepurchaseModal.hide()
      }
      if (theModalEl) {
        ProductPage.data.ajaxController.prepurchaseModal =
          new PwnageModalAddToCart(theModalEl, null)
      }
    }
  }) 
}
